import { NetImpactLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/net-impact/selection-state';
import {
  NetImpactLensData,
  NetImpactLensOptions,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { CarouselContext, useCarouselContext } from '../../../impact-lens-profile/context';

export function useNetImpactLensContext() {
  const context = useCarouselContext();
  if (context.lensType === ImpactLensType.UPRIGHT_NET_IMPACT) {
    const netImpactContext = context as CarouselContext<ImpactLensType.UPRIGHT_NET_IMPACT>;
    const data: NetImpactLensData = netImpactContext.data;
    // ML There must be a nicer way, probably with A extends ImpactLenType.Upright -similar conditional types.
    const options = netImpactContext.options as NetImpactLensOptions;
    const state = netImpactContext.selectionState;
    const setState = netImpactContext.setSelectionState;
    return { data, options, state, setState };
  }
  return undefined;
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return { data: undefined, options: {} as NetImpactLensOptions, state: {} as NetImpactLensSelectionState };
}
